<template>
  <div >
    <!-- {{value}} -->
    <div v-if="mode === 'DESIGN'" class="disabled-box max-width">
      <el-select v-model="_value" :placeholder="cityPlaceholder" size="small"  class="select-u" ></el-select>
      <el-input v-if="inputType ==='detail'" class="address" size="small" placeholder="请输入详细地址" :maxlength="20" show-word-limit :rows="2" type="textarea" />
    </div>
    <template v-else>
      <div v-if="!readerMode  || perm==='E'" >
        <!-- {{inputType}} -->
        <el-cascader
           class="select-u" 
          v-model="_value.value"
          :placeholder="cityPlaceholder" size="small"
          :props="cityProps"
          :options="selectList(inputType)"
          :disabled="perm==='R'"
          @change="change"></el-cascader>
        <el-input v-if="inputType ==='detail'"  v-model="_value.detail" :disabled="perm==='R'" @change="change" class="address" size="small" placeholder="请输入详细地址" :maxlength="20" show-word-limit :rows="2" type="textarea" />
  
      </div>
      <div v-else class="form-item-text">
        {{ valueText }}
      </div>
    </template>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'
import address from '@/utils/address'
export default {
  mixins: [componentMinxins],
  name: "AreaPicker",
  props: {
    value:{
      type: Object,
      default: () => {
        return {
          inputType:'',
          value:'',
          detail:''
        }
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    multiple:{
      type: Boolean,
      default: false
    },
    readerMode: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: ''
    },
  },
  computed: {
    cityPlaceholder() {
      if(this.inputType === 'city'){
        return '请选择省市'
      }else{
        return '请选择省市区'
      }
    },
    _value: {
      get: function () {
        this.value.inputType = this.inputType
        return this.value;
      },
      set: function (e) {
        console.log('dd',e)
        this.$emit("change", e);
      },
    },
    // 回显函数
    valueText() {
      if (!this.value.value && this.value.value.length==0) return ''
      let res = this.value.value.join('')
      if(this.inputType !== 'city'){
        res += this.value.detail  
      }
      return res
    }
  },
  data() {
    return {
      cityProps:{
        value:'name',
        label:'name',
      },
      options: address
    }
  },
  methods: {
    selectList(inputType) {
      if (!inputType) return [];
      if (inputType === 'city') {
        return this.options.map(item1 => ({
          ...item1,
          children: item1.children ? item1.children.map(item2 => ({
            ...item2,
            children: null
          })) : null
        }));
      } else {
        return this.options;
      }
    },
    change(e){
      if(e==''){
        // console.log('del',)
        this.$emit("delInput");
      }else if(this.value.value){
        if(this.inputType !== 'detail'){
          this.$emit("change", this.value);
        }else if(this.inputType === 'detail' && this.value.detail){
          this.$emit("change", this.value);
        }
      }
    },
    handleChange(value) {
        console.log('>>',value);
      }
  }
}
</script>

<style lang="scss" scoped>
.max-width{
  max-width: 320px;
}
.disabled-box .address{
  margin-top: 10px;
  /deep/.el-textarea__inner{
    padding-left: 8px;
  }
}
.process-form .address{
  margin-top: 10px;
  max-width: 320px;
  display: block;
}
.process-form-show .address{
  margin-top: 3px;
}
.select-u{
  width: 100%;
  max-width: 320px;
}
</style>
